<script lang="ts">
  export type TabId = 'realm' | 'contracts' | 'upgrades' | 'ascension' | 'more';
  interface Props { active: TabId; contractAttention?: boolean; onChange: (tab: TabId) => void }
  let { active, contractAttention = false, onChange }: Props = $props();
  const tabs: Array<{ id: TabId; icon: string; label: string }> = [
    { id: 'realm', icon: '⚔️', label: 'Realm' },
    { id: 'contracts', icon: '📜', label: 'Contracts' },
    { id: 'upgrades', icon: '🛠️', label: 'Upgrades' },
    { id: 'ascension', icon: '✦', label: 'Ascension' },
    { id: 'more', icon: '☰', label: 'More' }
  ];
</script>

<nav class="bottom-nav" aria-label="Primary navigation">
  {#each tabs as tab}
    <button
      type="button"
      class:active={active === tab.id}
      aria-current={active === tab.id ? 'page' : undefined}
      data-onboarding={tab.id === 'contracts' ? 'contracts-tab' : tab.id === 'upgrades' ? 'upgrades-tab' : tab.id === 'ascension' ? 'ascension-tab' : tab.id === 'more' ? 'more-tab' : undefined}
      onclick={() => onChange(tab.id)}
    >
      <span class="nav-icon" aria-hidden="true">{tab.icon}</span>
      <span>{tab.label}</span>
      {#if tab.id === 'contracts' && contractAttention}<i class="nav-attention" aria-label="Contracts need attention"></i>{/if}
    </button>
  {/each}
</nav>
